function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M294.7,424.39v-.16a3,3,0,0,1,2.3-3,2.76,2.76,0,0,1,.75-.1,3.06,3.06,0,0,1,2.07.81l.79-.85a4.23,4.23,0,0,0-2.86-1.12,4,4,0,0,0-1,.13,4.17,4.17,0,0,0-1.31.58,4.06,4.06,0,0,0-1,.94,4.18,4.18,0,0,0-.88,2.56.81.81,0,0,0,0,.16h-1.07l1.67,2.16,1.68-2.16Z",
  transform: "translate(-292.47 -420.02)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M303,424.08l-1.67-2.16-1.68,2.16h1.12v.16a3,3,0,0,1-2.3,3,3.2,3.2,0,0,1-.75.09,3.06,3.06,0,0,1-2.07-.81l-.79.85a4.17,4.17,0,0,0,2.86,1.12,4,4,0,0,0,1-.13,4.14,4.14,0,0,0,1.31-.57,4.47,4.47,0,0,0,1-.94,4.23,4.23,0,0,0,.88-2.57.86.86,0,0,0,0-.16Z",
  transform: "translate(-292.47 -420.02)"
});

function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.57 8.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.b6c1ec04.svg";
export { ForwardRef as ReactComponent };